/**
 * Visitor-facing labels of the 3D viewer, in the language the host page
 * (olyo-ai) loaded the project in — `params.fp_lang` of `newProjectLoaded`.
 * Unknown languages fall back to English.
 */
const LABELS = {
  en: {
    floor: "Floor",
    tour: "Tour",
    floorView: "Floor View",
    resetToStart: "Reset to start",
    previousPosition: "Previous position",
    nextPosition: "Next position",
    playAnimation: "Play animation",
  },
  he: {
    floor: "קומה",
    tour: "סיור",
    floorView: "נוף",
    resetToStart: "חזרה להתחלה",
    previousPosition: "המיקום הקודם",
    nextPosition: "המיקום הבא",
    playAnimation: "הפעלת אנימציה",
  },
  de: {
    floor: "Etage",
    tour: "Rundgang",
    floorView: "Aussicht",
    resetToStart: "Zum Anfang",
    previousPosition: "Vorherige Position",
    nextPosition: "Nächste Position",
    playAnimation: "Animation abspielen",
  },
};

let currentLang = "en";

export function setLang(lang) {
  currentLang = LABELS[lang] ? lang : "en";
}

export function tr(key) {
  return (LABELS[currentLang] && LABELS[currentLang][key]) || LABELS.en[key] || key;
}
